module.exports = __webpack_public_path__ + "img/laugh-active.d7e72b57.png";